
import { throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { retry } from 'rxjs/operators';

@Injectable ()
export class FireFunctionsApiService {
  public bearerToken: string;
  public currentUser: any;

  constructor(
    private http: HttpClient,
  ) {  }

  setHeaders(headerType, authenticate): HttpHeaders {
    let headersConfig: {[k: string]: any} = {};
    if (headerType === 'json') {
      headersConfig = {
        'Content-Type': 'application/json'
      };
    } else if (headerType === 'form') {
      headersConfig = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };
    } else if (headerType === 'multipart') {
      headersConfig = {
        // 'Content-Type': 'multipart/form-data' (not needed in Angular 4)
      };
    }
    if (authenticate) {
      if (localStorage.getItem('currentUser')) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        headersConfig['authorization'] = 'bearer ' + this.currentUser.access_token;
      }

    }


    return new HttpHeaders(headersConfig);
  }

  formatErrors(error: any) {
    return observableThrowError(error.json());
  }

  post(path: string, body, headerType: string, authenticate: boolean): Observable<any> {
    return this.http.post(environment.firefunction_api_url + path, body, { headers: this.setHeaders(headerType, authenticate) }).pipe(retry(2));
  }

  get(path: string, headerType: string, authenticate: boolean): Observable<any> {
    return this.http.get(environment.firefunction_api_url + path, { headers: this.setHeaders(headerType, authenticate) }).pipe(retry(2));
  }

  put(path: string, body, headerType: string, authenticate: boolean): Observable<any> {
    return this.http.put(environment.firefunction_api_url + path, body, { headers: this.setHeaders(headerType, authenticate) }).pipe(retry(2));
  }

  patch(path: string, body, headerType: string, authenticate: boolean): Observable<any> {
    return this.http.patch(environment.firefunction_api_url + path, body, { headers: this.setHeaders(headerType, authenticate) }).pipe(retry(2));
  }

  toggle(path: string, body, headerType: string, authenticate: boolean): Observable<any> {
    return this.http.put(environment.firefunction_api_url + path, body, { headers: this.setHeaders(headerType, authenticate) }).pipe(retry(2));
  }

  delete(path: string, headerType: string, authenticate: boolean): Observable<any> {
    return this.http.delete(environment.firefunction_api_url + path, { headers: this.setHeaders(headerType, authenticate)}).pipe(retry(2));
  }

  upload(path: string, file, headerType: string, authenticate: boolean): Observable<any> {
    return this.http.post(environment.firefunction_api_url + path, file, { headers: this.setHeaders(headerType, authenticate) }).pipe(retry(2));
  }

  uploadWithProgress(path: string, body, headerType: string, authenticate: boolean): Observable<any> {
    const headers = this.setHeaders(headerType, authenticate);
    return this.http.post(environment.firefunction_api_url + path, body, { headers: this.setHeaders(headerType, authenticate), reportProgress: true, observe: 'events' }).pipe(retry(2));
  }



}
